export default "__VITE_ASSET__e6f08067__"